import { APIClient } from "./axiosClient";

const api = new APIClient();

const path = "/courses";

const courseApi = {
  courseList(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },
};

export default courseApi;
